<template>
    <button class="button is-light is-danger" :class="{ 'is-loading': loading }" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-stop"></i>
    </span>
    <span v-if="label">{{label}}</span>
  </button>
</template>

<script>
export default {
  name: 'UnpublishButton',
  props: {
    label: String,
    loading: Boolean
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/UnpublishButton.vue